(function (employments, $) {

    /* On synchronize button clicked, synchronize and trigger the correct form action on click */
    employments.SynchronizeButtonClick = function (profitEnvironmentKey) {
        var button = $("[data-synchronize-modules]");
        globalCore.showSpinner();
        globalCore.OnSubmitBegin(button);
        $.ajax({
            method: "GET",
            url: '/Checks/EmploymentChecker/Synchronize',
            data: { 'profitEnvironmentKey': profitEnvironmentKey },
            complete: function (result) {
                globalCore.hideSpinner();
                globalCore.OnSubmitComplete(button);
                globalCore.onModalSuccess(result.responseJSON);
                // Also hide modal on failure
                $("#modalcontainer").modal("hide");
                globalCore.ShowAlert(result.responseJSON.success, "#sync-alert-container-employmentchecker", "De synchronisatie is voltooid.", "Er is iets fout gegaan tijdens het synchroniseren.");
                if (result.responseJSON.success) {
                    $('#searchform').submit();
                }
            }
        });
    }

    /* Initialize the Employment details datatable */
    employments.InitEmploymentDetailsGrid = function (profitEnvironmentKey, employerCode, start, end) {
        $("#showEmployeeDetailsButton").hide();
        $.ajax({
            url: "/Checks/EmploymentChecker/EmployeeDetails",
            dataType: "json",
            data: {
                profitEnvironmentKey: profitEnvironmentKey,
                employerCode: employerCode,
                start: start,
                end: end
            },

            success: function (employmentDetails) {
                $.fn.dataTable.moment('DD-MM-YYYY HH:mm');
                $("#employmentDetailsGrid").DataTable(datatable.defaultDataTableOptions({
                    serverSide: false,
                    data: employmentDetails,
                    columns: [
                        {
                            title: 'Profit code',
                            data: 'code'
                        },
                        {
                            title: 'Indiensttreding',
                            data: 'dateInService'
                        },
                        {
                            title: 'Uitdiensttreding',
                            data: 'dateOutService'
                        }
                    ],
                    columnDefs: [
                        {
                            targets: [1, 2],
                            render: function (data, type, full, meta) {
                                return datatable.dutchDateFormat(data, "DD-MM-YYYY HH:mm")
                            }
                        }
                    ],
                    order: [[1, 'desc']]
                }));
            }
        });
    }

}(window.employments = window.employments || {}, $));
